import React from 'react';
import { Box } from "@mui/material";
import CommonHeading from "../../components/commonComponents/commonHeading";
import { Outlet, useOutletContext } from "react-router-dom";
import CommonBreadcrumbs from "../../components/commonComponents/CommonBreadcrumbs";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

interface ContextType {
  activeStep: number;
  setActiveStep: (step: number) => void;
}

export const IndentityVerificationWrapper = () => {
    const navigate = useNavigate();
    const [activeStep, setActiveStep] = useState(1);

    const appBreadCrumbs = [
        {
          href: "",
          label: "Home",
          onClick: () => {
            navigate("/home")
          }
        },
        {
          href: "",
          label: "Purchase Profile",
          onClick: () => {
            navigate("/purchaseprofile")
          }
        },
    ];

    const context: ContextType = {
        activeStep,
        setActiveStep
    };

    return (
        <Box bgcolor={"#f8f8f8"} className="space-y-5">
            <CommonHeading  sx={{ mb: 2, fontWeight: "600", fontSize: 22,mt:{sm:"20px",md:"0px",xs:"2px"} }} heading={"Add Profiles"} />
            <CommonBreadcrumbs
                items={appBreadCrumbs}
                final={{ href: "", label: "Add Profile" }}
            />
            <Outlet context={context} />
        </Box>
    );
};

export default IndentityVerificationWrapper;

// This allows TypeScript to understand the type of the context
export function useIdentityVerification() {
    return useOutletContext<ContextType>();
}